import React from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import ProductCard1 from "../../components/ProductCard/ProductCard1";
import ErrorPage from "../../shared/ErrorPage";
import Loading from "../../shared/Loading";
import axiosInstance from "../../utilities/axiosInstance/axiosInstance";

const HomeSection2 = () => {
  const navigate = useNavigate();
  const {
    isLoading,
    isError,
    data: products,
    error,
  } = useQuery(["productsec2"], async () => {
    let fdata = await axiosInstance.get("product/get?limit=8");
    return fdata.data;
  });

  const {
    isLoading1,
    isError1,
    data: discount,
    error1,
  } = useQuery(["discountdata"], async () => {
    let fdata = await axiosInstance.get("discount/get-active?limit=1");
    // console.log(fdata.data[0]);
    return fdata.data[0];
  });

  if (isError || isError1) return <ErrorPage msg={error || error1}></ErrorPage>;

  if (isLoading || isLoading1) return <Loading msg="Loading..."></Loading>;

  return (
    <section className="w-full mb-16 ">
      {/* DELIVERY | 24SUPPORT | MONEY RETURN |DISCOUNT */}
      <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 justify-center items-center gap-4 border border-gray-300 p-2 mb-16">
        <div className=" flex justify-center items-center py-4">
          <img
            className="w-16 mr-4"
            src="https://cdn-icons-png.flaticon.com/512/2769/2769339.png"
            alt=""
          />
          <p>
            <span className="font-bold text-sm">EXPRESS DELIVERY</span>
            <br />
            <span className="text-sm">Inside Dhaka 2/3Days Delivery </span>
          </p>
        </div>
        <div className=" flex justify-center items-center py-4">
          <img
            className="w-14 mr-4"
            src="https://cdn-icons-png.flaticon.com/512/5167/5167002.png"
            alt=""
          />
          <p>
            <span className="font-bold text-sm">ONLINE SUPPORT 24/7</span>
            <br />
            <span className="text-sm">Support online 24 hours</span>
          </p>
        </div>
        <div className=" flex justify-center items-center py-4">
          <img
            className="w-14 mr-4"
            src="https://cdn-icons-png.flaticon.com/512/2394/2394090.png"
            alt=""
          />
          <p>
            <span className="font-bold text-sm">MONEY RETURN</span>
            <br />
            <span className="text-sm">
              Replacement/Moneyback guarantee under product damages
            </span>
          </p>
        </div>
        <div className=" flex justify-center items-center py-4">
          <img
            className="w-14 mr-4"
            src="https://cdn-icons-png.flaticon.com/512/2652/2652181.png"
            alt=""
          />
          <p>
            <span className="font-bold text-sm">MEMBER DISCOUNT</span>
            <br />
            <span className="text-sm">Onevery Special Event Discount</span>
          </p>
        </div>
      </div>

      <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 lg:gap-10 sm:gap-4">
        {discount &&
          products &&
          products.map((x, index) => {
            return (
              <ProductCard1
                key={index}
                props={x}
                discountData={discount}
              ></ProductCard1>
            );
          })}
      </div>

      {/* 2 card on same line */}
      <div className="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-10 mt-16 hover:cursor-pointer">
        <div
          onClick={() => navigate("/ship")}
          className="bg1 border border-gray-300 p-10 flex"
        >
          <div className="text-white lg:w-7/12 sm:w-full">
            <p className="text-lg">Buy From</p>
            <p className="my-1 text-xl font-semibold">
              International Market Place & Ship them BD
            </p>
          </div>
          <div className=""></div>
        </div>
        <div
          onClick={() => navigate("/ship")}
          className="bg2 border border-gray-300 p-10 flex justify-between hover:cursor-pointer"
        ></div>
      </div>
    </section>
  );
};

export default HomeSection2;
